namespace $.$$ {
	$mol_style_define( $shm_mentionstat_filter_panel, {
		width: '24rem',
		flex: { basis: '24rem', grow: 0, shrink: 0 },
		Filters: { flexDirection: 'column', width: '100%' },
		Query_list: { flexDirection: 'column' },
		Scope_list: { flexDirection: 'column' },
		Country_list: { flexDirection: 'column' },
		Language_list: { flexDirection: 'column' },
		Type_list: { flexDirection: 'column' },
		Category_list: { flexDirection: 'column' },
	} )

	$mol_style_define( $shm_mentionstat_filter_panel_row, {
		position: 'relative',
		minWidth: 0,
		':hover': {
			Only: {
				opacity: 1,
				pointerEvents: 'auto',
			},
		},
		Check: {
			minWidth: 0,
			justifyContent: 'flex-start',
			flex: {
				grow: 1,
				shrink: 1,
			},
			Title: {
				minWidth: 0,
				whiteSpace: 'normal',
				overflowWrap: 'anywhere',
			},
		},
		Only: {
			opacity: 0,
			pointerEvents: 'none',
			position: 'absolute',
			right: 0,
			height: '100%',
			minHeight: 0,
			minWidth: 0,
			zIndex: $mol_layer.hover,
			background: { color: $mol_theme.back },
			padding: {
				left: $mol_style_unit.px( 6 ),
				right: $mol_style_unit.px( 6 ),
				top: $mol_style_unit.px( 2 ),
				bottom: $mol_style_unit.px( 2 ),
			},
			font: { size: $mol_style_unit.px( 12 ) },
		},
	} )
}
